import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import AnimatedPage from "../components/AnimatedPage";
import Header from "../components/Header";
import Footer from "../components/Footer";

function Profile() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const navigate = useNavigate();

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
            
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
            if (setting !== res.data.data[0]) {
                setSetting(res.data.data[0]);
                localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
            }
        });
    }, [profile, setting]);

    return (
        <AnimatedPage>
            {/* THÊM HEADER VÀO TRÊN CÙNG */}
            <Header profile={profile} />

            <style>{`
                /* CẤU HÌNH TRANG CHUNG */
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    overflow-y: auto !important;
                    background-color: #e3e1e2 !important; 
                    margin: 0; padding: 0;
                }
                
                /* FIX TRIỆT ĐỂ NỀN XANH: ÉP NỀN XÁM VÀO WRAPPER TỔNG */
                .profile-wrapper {
                    padding-bottom: 100px; 
                    position: relative;
                    background-color: #e3e1e2 !important; /* Ghi đè mọi màu nền khác */
                    min-height: 100vh; /* Che phủ toàn bộ chiều cao màn hình */
                }

                /* ================================================== */
                /* PHẦN ĐẦU TRANG: DÙNG ẢNH NỀN BANNER BẠN ĐƯA        */
                /* ================================================== */
                .center-head {
                    width: 100%;
                    height: 180px;
                    background: url('https://dztwieyphe62d.cloudfront.net/content/images/main/user/banner-center.jpg') center top no-repeat;
                    background-size: cover;
                    padding: 0 20px; 
                    display: flex;
                    align-items: center; 
                    margin: 0 0 10px;
                    color: #fff;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                }

                .profile-avatar-wrapper {
                    position: relative; 
                    margin-right: 15px; 
                    flex-shrink: 0;
                }

                .profile-avatar {
                    width: 65px; 
                    height: 65px;
                    background-color: #fff;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .profile-avatar i {
                    font-size: 38px;
                    color: #ffca28; 
                }

                .profile-v1-badge {
                    position: absolute;
                    top: -2px;
                    right: -5px;
                    background-color: #ff9800; 
                    color: #fff;
                    border-radius: 50%;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 11px;
                    font-weight: bold;
                    border: 2px solid #222;
                }

                /* CHẶN CĂN GIỮA, ÉP CĂN TRÁI CHO KHỐI CHỮ */
                .profile-info {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center; 
                    text-align: left !important; 
                }
                .profile-info h3 {
                    margin: 0 0 2px 0;
                    font-size: 16px; 
                    font-weight: bold;
                    color: #fff;
                    line-height: 1.1;
                    text-align: left !important;
                }
                .profile-info p.email {
                    margin: 0 0 6px 0;
                    font-size: 13px;
                    color: #ddd;
                    line-height: 1.1;
                    text-align: left !important;
                }
                .profile-stats p {
                    margin: 2px 0;
                    font-size: 13px;
                    color: #fff;
                    line-height: 1.2;
                    text-align: left !important;
                }
                .profile-stats span {
                    color: #ff9800; 
                    font-weight: bold;
                }

                /* ================================================== */
                /* DANH SÁCH MENU (CÁC KHỐI TRẮNG)                    */
                /* ================================================== */
                .profile-menu-container {
                    padding: 5px 12px;
                }
                
                .profile-menu-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    background-color: #fff;
                    padding: 14px 15px; 
                    margin-bottom: 8px; 
                    border-radius: 4px; 
                    color: #222;
                    text-decoration: none !important; 
                    font-size: 14px; 
                    font-weight: 500;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                    cursor: pointer;
                }
                
                /* CHẶN GẠCH CHÂN KHI ẤN/DI CHUỘT */
                .profile-menu-item:hover, 
                .profile-menu-item:active, 
                .profile-menu-item:focus {
                    background-color: #f0f0f0;
                    text-decoration: none !important;
                    outline: none;
                }
                
                .profile-menu-item svg {
                    color: #ccc; 
                    font-size: 20px; 
                }
            `}</style>

            <div className="profile-wrapper">

                {profile && (
                    <>
                        {/* THÔNG TIN USER VỚI ẢNH NỀN BANNER */}
                        <div className="center-head">
                            <div className="profile-avatar-wrapper">
                                <div className="profile-avatar">
                                    <i className="fa-solid fa-user"></i>
                                </div>
                            </div>
                            <div className="profile-info">
                                <h3>{profile.username}</h3>
                                
                                <div className="profile-stats">
                                    <p>Mã mời : <span>{profile.code}</span></p>
                                    <p>Số điểm : <span>{profile?.money ? Math.floor(profile.money / 1000).toLocaleString("vi-VN") : "0"}</span></p>
                                </div>
                            </div>
                        </div>

                        {/* DANH SÁCH MENU MỚI NHỎ GỌN NHƯ ẢNH */}
                        <div className="profile-menu-container">
                            
                        

                            <Link to="/password" className="profile-menu-item">
                                Đổi Mật Khẩu
                                <KeyboardArrowRightOutlinedIcon />
                            </Link>

                            <Link to="/recharge/bank" className="profile-menu-item">
                                Nạp Tiền
                                <KeyboardArrowRightOutlinedIcon />
                            </Link>

                            <Link to="/withdraw" className="profile-menu-item">
                                Rút Tiền
                                <KeyboardArrowRightOutlinedIcon />
                            </Link>

                            <Link to="/historyplay" className="profile-menu-item">
                                Báo Cáo Cược
                                <KeyboardArrowRightOutlinedIcon />
                            </Link>

                            <Link to="/historycasino" className="profile-menu-item">
                                Lịch Sử Cược
                                <KeyboardArrowRightOutlinedIcon />
                            </Link>

                            <Link to="/recharge_record" className="profile-menu-item">
                               Lịch sử nạp
                                <KeyboardArrowRightOutlinedIcon />
                            </Link>
   <Link to="/withdraw_record" className="profile-menu-item">
                               Lịch sử rút
                                <KeyboardArrowRightOutlinedIcon />
                            </Link>
                            <Link to="/transfergame" className="profile-menu-item">
                                Chuyển Ví
                                <KeyboardArrowRightOutlinedIcon />
                            </Link>

                            <Link to="/history" className="profile-menu-item">
                               Lịch sử chuyển tiền sảnh
                                <KeyboardArrowRightOutlinedIcon />
                            </Link>

                            <Link to="/addbank" className="profile-menu-item">
                                Liên kết ngân hàng
                                <KeyboardArrowRightOutlinedIcon />
                            </Link>
                            
                            <Link to="/invite" className="profile-menu-item">
                                Mời bạn bè
                                <KeyboardArrowRightOutlinedIcon />
                            </Link>
                            
                            <Link to="/pass2" className="profile-menu-item">
                                Đổi mật khẩu rút tiền
                                <KeyboardArrowRightOutlinedIcon />
                            </Link>

                            {/* Nút Đăng Xuất */}
                            <div 
                                className="profile-menu-item"
                                onClick={() => {
                                    localStorage.removeItem("user");
                                    localStorage.removeItem("currentUser");
                                    localStorage.removeItem("profile");
                                    localStorage.removeItem("data");
                                    localStorage.removeItem("data1");
                                    var now = new Date();
                                    var time = now.getTime();
                                    var expireTime = time;
                                    now.setTime(expireTime);
                                    document.cookie = "jwt=;Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                                    navigate("/login");
                                }}
                            >
                                Đăng xuất
                                <KeyboardArrowRightOutlinedIcon />
                            </div>
                        </div>
                    </>
                )}
            </div>
            
            {/* THÊM FOOTER VÀO DƯỚI CÙNG */}
            <Footer />
        </AnimatedPage>
    );
}

export default Profile;